import { OutboundInvoiceSchema } from "@redotech/redo-model/balance/outbound-invoice";
import * as z from "zod/v4";

export const getOutboundInvoices = {
  name: "getOutboundInvoices" as const,
  input: z.object({
    beforeTimestamp: z.number().optional(),
    limit: z.number().optional().default(50),
    search: z.string().optional(),
  }),
  output: z.object({ invoices: z.array(OutboundInvoiceSchema) }),
};
